import React, {PureComponent} from 'react'
import './News.css'

class News1 extends PureComponent {
	render() {
		return (
			<div style={{maxWidth: '667px', margin: 'auto'}}>
				<div id="img-content">
					<h2 className="rich_media_title" id="activity-name">
						老板，开连锁店吗？开之前，你需要知道这些……
					</h2>
					<div className="rich_media_content" id="js_content">
						<section style={{
							letterSpacing: '0px',
							paddingRight: '6px',
							paddingLeft: '6px',
							fontSize: '16px',
							lineHeight: 2,
							boxSizing: 'border-box'
						}}>
							<section>
								<p>
									<span style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;<strong>连锁</strong>简直无处不在。连锁门店的盈利规模也不用多提。更好玩的事实是，当你的连锁慢慢做起来，盈利会变得越来越简单，账面的数字也会越来越好看。</span>
								</p>
								<p>
									<br/>
								</p>
							</section>
							<section>
								<p>
									<span
										style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;对于开连锁店的老板们和即将开连锁店的老板们来讲，连锁门店的可复制性是大家颇为关心的话题。</span>
								</p>
								<p>
									<span
										style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;复制粘贴这个过程有两点是重中之重：<strong>1.强大的管理系统。</strong><strong>2.人员的统一培训。</strong></span>
								</p>
								<p><br/></p>
								<p>
									<span
										style={{fontSize: '16px'}}>&nbsp;&nbsp;&nbsp;&nbsp;管理系统的需求是在而统一管理是决定连锁企业能否持续稳定增长、未来收入是否可预测的关键因素。而高标准化也是连锁门店的特点之一。</span>
								</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F4.1.webp"/>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<p className='text-center'>
									<span style={{fontSize: '12px'}}>麦当劳是走进中国最早的一批企业之一，“金拱门”的标识深入人心。</span>
								</p>
								<p>
									<br/>
								</p>
								<p>
									<span>&nbsp;&nbsp;&nbsp;&nbsp;也就是说：能够做到<strong>统一进货、统一管理、统一标准规范</strong>——你的店就成功一大半了。</span>
								</p>
								<p>
									<span>&nbsp;&nbsp;&nbsp;&nbsp;而统一化管理一直店面管理中花费时间最多、最劳心劳神的部分。</span>
								</p>
								<p className='text-center text-bold'>
									<span>如何用最简洁高效的方式去管理所有门店？</span>
								</p>
								<p><br/></p>
								<p className='text-center text-bold'>
									<span>如何能做到人在家中坐，门店信息八方来？</span>
								</p>
								<p><br/></p>
								<p className='text-center text-bold'>
									<span>如何将员工统一培训效果又好又不花费太多成本？</span>
								</p>
								<p><br/></p>
								<p>
									<span>&nbsp;&nbsp;&nbsp;&nbsp;面对这些痛点，美未凭借自身颜值与科技（主要是靠科技）给出了以下的解决方案。</span>
								</p>
								<p><br/></p>
								<p className='text-bold'>如何用高效简洁的方式去管理？</p>
								<p><br/></p>
								<p className='text-center'>章鱼的触角不管有多少，行动完全受大脑指挥。</p>
								<p>&nbsp;&nbsp;&nbsp;&nbsp;连锁门店同理。</p>
								<p>&nbsp;&nbsp;&nbsp;&nbsp;一个高效的总控平台可以将繁忙工作分解，简化工作流程，提高效率。建立一个大脑般可处理信息、控制每一个门店信息的总控平台，可解决分支门店与大脑总控的关系——只要你店内有美未屏幕即可。</p>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F4.2.webp"/>
							</section>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;美未总控平台 是东方嘉禾话大力气研究、为此<strong>一不小心拿了24个软件著作权</strong>的 连锁门店统一化管理的平台。</p>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;这个平台可以满足连锁门店总控部门控制单一设备、地区设备、全部设备的需求，并能实现平台推送宣传资料、市场活动、优惠信息等图片视频到各指定门店。</p>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F4.3.webp"/>
							</section>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;平台目前被公司处女座的程序员们优化了<strong>17</strong>次，已经达到了傻瓜式操作的要求，<strong>界面简洁，谁看谁会，上手极快</strong>。</p>
							<p><br/></p>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;考虑到单独门店遇到特殊情况需要控制屏幕，我们还在系统设置了门店管理员扫码控屏的功能。单一门店的画面更改、内容更新在美未总控平台可以被检测到，并提示给总台控制中心。</p>
							<p><br/></p>
							<p className='text-center text-bold'>
								真·人在家中坐，信息八方来。
							</p>
							<p><br/></p>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;其实总控平台的实施早在90年代的美国已经开始实施了。很多在华开分店的外企都自费研发了自己的操作平台。研发费用之高昂，令人咋舌。</p>
							<p className='text-bold'>&nbsp;&nbsp;&nbsp;&nbsp;美未总控平台属于美未屏幕的附带功能……</p>
							<p className='text-center text-bold'>
								你没看错。
							</p>
							<p className='text-center text-bold'>
								附。带。功。能。
							</p>
							<p><br/></p>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;目前买了屏幕，统一管理功能可以自由领取~</p>
							<p><br/></p>
							<p className='text-bold'>如何将员工统一培训效果又好又不花费太多成本？</p>
							<p><br/></p>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;统一的员工培训也是连锁门店的大问题。</p>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;统一的品牌标识、门店装修风格、员工服饰等都是连锁门店识别度的构成部分。而目前，人员统一化的服务越来越成为连锁品牌的标志之一。具体请参考海底捞。</p>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F4.4.webp"/>
							</section>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F4.5.webp"/>
							</section>
							<p><br/></p>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;实施在不同地区雇佣员工进行培训的各项成本都很高。外企零售行业的普遍解决办法是研发手机端app供员工下载，并在上面提供相关学习资料，考评内容等。</p>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;但是，手机终端的监督力度只停留在app系统里的“二次元监控”，也就是说，即使保证app学习过程设计的非常完美，也不能保证每个员工在现实过程中没有使用其他的骚操作。</p>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F4.6.webp"/>
							</section>
							<p className='text-center' style={{fontSize: '12px'}}>心照不宣嘴角疯狂的上扬</p>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;美未总控平台支持上传的视频同步播出。区别于个体学习，店员在指导下集体学习更有氛围。集体学习的好处就不说了，在古代即使读私塾也要招伴读的。</p>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;不仅如此，美味总控平台开发了另一个功能……</p>
							<p className='text-center text-bold'>在线直播功能。</p>
							<p><br/></p>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;除了必要提前录制好的教学视频播放之外，还可以在线连线直播。总控平台的直播画面可以传输到各个分店的屏幕上，画面实时同步。</p>
							<p className='text-bold text-center'>真·感觉买了一家电视台的feel。</p>
							<p><br/></p>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;以上两点是美未智能屏为了解决统一化管理所做的一点微小的贡献。（面对门店如何解决排队问题的解决方案参见上期链接。。。）</p>
							<p><br/></p>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;美未传媒功能屏分为对外宣传屏（橱窗屏、互动引流屏）和店内宣传屏（菜单屏、广告屏）。对外宣传屏幕可以通过广告海报、屏幕互动等形式为门店聚集人气、招揽客户。像下图这样~</p>
							<p><br/></p>
							<section style={{marginTop: '10px', marginBottom: '10px'}}>
								<img style={{width: '100%'}} src="https://mewephoto.oss-cn-beijing.aliyuncs.com/meweweb%2F4.7.webp"/>
							</section>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;店内宣传屏幕可以在闲暇时段，由集团总部操控，通过全球各分店屏幕对员工进行统一培训、开会等，以此减少沟通成本、提高效率，为集团统一化管理赋能。</p>
							<p><br/></p>
						</section>
					</div>
				</div>
			</div>
		)
	}
}

export default News1


// WEBPACK FOOTER //
// ./src/News4.js